<template>
    <div class="row text-center">
        <div class="principal content">
            <h3>
                {{ actualAction.action }}
            </h3>

            <p>
                <span v-html="actualAction.subaction"></span>
                <span class="hidden-xs-down"
                    >Confira o <a @click="openModal = true">regulamento</a> para saber mais.</span
                >
            </p>

            <p class="hidden-xs-up">
                Confira o <a @click="openModal = true">regulamento</a> para saber mais.
            </p>

            <div class="d-flex flex-align-center flex-justify-center mb-4 flex-spaced-fixed">
                <p>Ative seu cupom clicando aqui:</p>
                <button
                    class="btn btn-xl px-5 btn-light add-cupom-click"
                    data-cupom-name="8%2FEMc%2FXxV1MzMjAy1jUw1DU2VDAytjK1BCIA"
                >
                    Livelo
                </button>
            </div>

            <div class="content mt-3 mb-3">
                <hr class="anchorSpace" />
            </div>
        </div>

        <Modal v-model="openModal">
            <template v-slot:title> Acúmulo de Pontos Livelo /Chico Rei</template>
            <div class="card-block modal text-left">
                <p>
                    Ao realizar as compras na loja virtual da Chico Rei, em www.chicorei.com/livelo
                    (“Hotsite”), o cliente aceita e concorda com as regras contidas abaixo.
                </p>

                <div>
                    <p>
                        <strong>1. Participantes:</strong> São as pessoas físicas, maiores de
                        dezoito anos, que ao adquirirem produtos vendidos e entregues pela Chico Rei
                        no <a :href="this.$scope.URL + 'livelo'">www.chicorei.com/livelo</a>; sejam
                        titulares do CPF informado durante o processo de compra no Hotsite e cumpram
                        todas as condições deste regulamento e do regulamento do Programa Livelo,
                        disponível em
                        <a @click="liveloRegulamento">www.livelo.com.br/regulamento</a>.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>2. Campanha:</strong> Terão direito ao acúmulo de Pontos Livelo, nos
                        termos deste regulamento, os participantes que, cumulativamente
                    </p>
                    <ol type="i">
                        <li>adquirirem produtos vendidos e entregues por Chico Rei no Hotsite.</li>
                        <li>
                            incluam o cupom disponibilizado denominado:
                            <strong>LIVELO </strong>
                            (com todas as letras maiúsculas) no campo
                            <strong>"Cupom" </strong> na sacola de compras no Hotsite, antes de
                            concluir a sua compra para acumular Pontos Livelo.
                        </li>
                    </ol>
                </div>

                <div>
                    <p>
                        <strong>3. Período:</strong> A presente Campanha é válida por tempo
                        indeterminado, podendo ser encerrada mediante prévio aviso de 30 (trinta)
                        dias por parte da Chico Rei.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>4. Montante de acúmulo:</strong> Os Participantes elegíveis, que
                        cumprirem as condições deste regulamento, poderão acumular de duas formas:
                    </p>
                    <ol type="i">
                        <li>
                            <strong><u>Acúmulo Padrão:</u></strong>
                            1 (um) Ponto Livelo a cada R$1 (um real) em compras para todos os
                            Participantes, podendo ser alterado pela Chico Rei a qualquer tempo; ou
                        </li>
                        <li>
                            <strong><u>Acúmulo Especial:</u></strong>
                            : 2 (dois) ou mais Pontos Livelo a cada real em campanhas especiais
                            válidas por tempo determinado, conforme regras e mecânicas definidas na
                            própria oferta/campanha.
                        </li>
                    </ol>
                    <ul style="list-style: none">
                        <li>
                            <span class="mr-3">4.1.</span> Em uma compra, o Participante somente
                            pode acumular Pontos OU pelo Acúmulo Padrão OU Acúmulo Especial a
                            depender das regras definidas na oferta, não sendo possível acumular
                            Pontos nas duas modalidades.
                        </li>
                        <li>
                            <span class="mr-3">4.2.</span> Para campanhas/ofertas que tiverem como
                            critério a necessidade de ser assinante do Clube Livelo, serão elegíveis
                            apenas os assinantes que (i) tiverem realizado sua adesão ao Clube
                            Livelo antes de adquirir produtos no Hotsite e (ii) permanecer com sua
                            assinatura ativa até o crédito dos Pontos Livelo.
                        </li>
                    </ul>
                </div>

                <div>
                    <p>
                        <strong>5. Pontos Acumulados:</strong> A quantidade de pontos a serem
                        creditados será definida pela Chico Rei, e esta comunicará a Livelo para que
                        proceda com o crédito devido.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>6. Validade dos Pontos: </strong> Os Pontos oriundos desta Campanha
                        de Incentivo terão validade de 24 (vinte e quatro) meses a contar da data de
                        creditamento na Conta Livelo do Participante.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>7. Prazo para Crédito de Pontos: </strong>Os Pontos Livelo serão
                        creditados em até 30 (trinta) dias corridos contados do recebimento, pelo
                        cliente, do produto adquirido no www.chicorei.com/livelo, desde que o número
                        do CPF informado seja válido.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>8. ATENÇÃO: O que não acumula Pontos:</strong>
                        Não acumulam Pontos Livelo (i) embalagens para presente, (ii) frete, (iii)
                        valores pagos com Cupom de Desconto, gift card e Vale-Compra; (iv) pedidos
                        realizados por pessoa jurídica; e (v) compras realizadas fora do Hotsite
                        www.chicorei.com/livelo. Também não serão creditados Pontos Livelo para (i)
                        pedidos não aprovados ou cancelados; (ii) produtos devolvidos pelo
                        Participante; (iii) caso de suspeita de fraude; (iv) compra de
                        vale-presente, (v) em hipótese de violação deste regulamento ou regulamento
                        do Programa Livelo; e Produtos que não são vendidos e nem entregues pela
                        Chico Rei.
                        <strong
                            >COMPRAS EFETUADAS EM CANAIS NÃO INFORMADOS NESTE REGULAMENTO NÃO SERÃO
                            PASSÍVEIS DE ACÚMULO DE PONTOS LIVELO.
                        </strong>
                    </p>
                </div>

                <div>
                    <p>
                        <strong>9. Não cumulatividade:</strong> Esta Campanha não é cumulativa com
                        outras promoções, bonificações ou descontos.
                    </p>
                </div>

                <div>
                    <p>
                        <strong>10. Responsabilidade:</strong> A Livelo não se responsabiliza pela
                        qualidade dos produtos e serviços oferecidos e disponibilizados pela Chico
                        Rei. A Livelo não se responsabiliza por informações incorretas apresentadas
                        pela Chico Rei e/ou Participante, incluindo, mas não se limitando ao número
                        de CPF para proceder com o crédito de Pontos. Cabe a Chico Rei definir a
                        conversão de dólar para real em campanhas realizadas na paridade dólar por
                        ponto.
                    </p>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import Modal from '../common/container/Modal.vue';

    export default {
        name: 'Livelo',

        components: {
            Modal,
        },

        data() {
            return {
                openModal: false,
                campanha: [
                    {
                        content: ``,
                    },
                    {
                        content: `

                            `,
                        subtitle: [
                            {
                                text: `
                                        Em uma compra, o Participante somente pode acumular Pontos OU pelo Acúmulo
                                        Padrão OU Acúmulo Especial a depender das regras definidas na oferta, não sendo
                                        possível acumular Pontos nas duas modalidades.
                                    `,
                            },
                            {
                                text: `
                                        Para campanhas/ofertas que tiverem como critério a necessidade de ser assinante
                                        do Clube Livelo, serão elegíveis apenas os assinantes que (i) tiverem realizado
                                        sua adesão ao Clube Livelo antes de adquirir produtos no Hotsite e (ii)
                                        permanecer com sua assinatura ativa até o crédito dos Pontos Livelo.
                                    `,
                            },
                        ],
                    },
                ],
                howItWorks: [
                    'Acesse o hotsite exclusivo da parceria: chicorei.com/itaushop',
                    'Escolha os produtos que você desejar',
                    'Insira o cupom ITAU',
                    'Pague com seu cartão de crédito elegível Itaú',
                    'Ganhe 3 pontos Itaú a cada 1 real gasto no site específico da parceria',
                    'Essa promoção não é cumulativa com a promoção de desconto vigente do hotsite',
                    'Seus pontos Itaú serão creditados diretamente em sua conta Itaú em até 70 (setenta) dias após a data de efetivação da sua compra.',
                ],
                notCredited: [
                    'pedidos não aprovados ou cancelados',
                    'produtos devolvidos pelo Cliente',
                    'em casos de suspeita de fraude',
                    'em hipóteses de violação deste Regulamento',
                ],
            };
        },

        computed: {
            actualAction() {
                const today = new Date();
                let messages = {
                    action: 'A cada R$ 1 gasto na Chico Rei, você ganha 1 ponto Livelo :)',
                    subaction:
                        'Pra ganhar seus pontos, adicione o cupom LIVELO na sacola e finalize suas compras.',
                };

                const dateRanges = [
                    {
                        startDate: new Date(2024, 8, 10, 0, 0, 0),
                        endDate: new Date(2024, 8, 10, 23, 59, 59),
                        messages: {
                            action: 'A cada R$ 1 gasto na Chico Rei, você ganha até 10 pontos Livelo :)',
                            subaction:
                                'Pra ganhar seus pontos, adicione o cupom LIVELO na sacola e finalize suas compras.' +
                                '<br />' +
                                'São 10 pontos para clientes Clube Livelo e 8 ponto para demais\n' +
                                'clientes a cada 1 real gasto.\n' +
                                '<br />' +
                                'Válido apenas para os produtos selecionados abaixo. <br />',
                        },
                    },
                    {
                        startDate: new Date(2024, 8, 18, 0, 0, 0),
                        endDate: new Date(2024, 8, 19, 23, 59, 59),
                        messages: {
                            action: 'A cada R$ 1 gasto na Chico Rei, você ganha até 12 pontos Livelo :)',
                            subaction:
                                'Pra ganhar seus pontos, adicione o cupom LIVELO na sacola e finalize suas compras.' +
                                '<br />' +
                                'São 10 pontos para clientes Clube Livelo e 10 pontos para demais\n' +
                                'clientes a cada 1 real gasto.\n' +
                                '<br />' +
                                'Válido apenas para os produtos selecionados abaixo. <br />',
                        },
                    },
                    {
                        startDate: new Date(2024, 5, 26, 6, 0, 0),
                        endDate: new Date(2024, 5, 27, 23, 59, 59),
                        messages: {
                            action: 'A cada R$ 1 gasto na Chico Rei, você ganha 12 pontos Livelo :)',
                            subaction:
                                'Pra ganhar seus pontos, adicione o cupom LIVELO na sacola e finalize suas compras.' +
                                '<br />' +
                                'São 12 pontos para clientes Clube Livelo e 10 pontos para demais\n' +
                                'clientes a cada 1 real gasto.\n' +
                                '<br />' +
                                'Válido apenas para os produtos selecionados abaixo. <br />',
                        },
                    },
                ];

                for (const range of dateRanges) {
                    if (today >= range.startDate && today <= range.endDate) {
                        return range.messages;
                    }
                }

                return messages;
            },
        },

        methods: {
            submit() {
                window.location.href =
                    this.$scope.URL + '?voucher=8wxxDFVTMzIwMtI1NNI1MFQwMrYytQQiAA%3D%3D';
            },

            liveloRegulamento() {
                window.open('https://www.livelo.com.br/regulamento', '_blank');
            },
        },
    };
</script>
